import { render, staticRenderFns } from "./ReviewsAlt.vue?vue&type=template&id=9458510a&"
import script from "./ReviewsAlt.vue?vue&type=script&lang=js&"
export * from "./ReviewsAlt.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAlt.vue?vue&type=style&index=0&id=9458510a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UITrustpilotWidget: require('/opt/build/repo/components/UI/TrustpilotWidget.vue').default})
